import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import type { ProfessionalDetailCrossLink } from '@/application/metrics/professionalDetailCrossLinks';

interface ProfessionalDetailCrossLinksProps {
  links: ProfessionalDetailCrossLink[];
}

/**
 * CTAs a otros dominios desde el detalle (tenant + periodo ya van en cada href).
 * Targets táctiles razonables en mobile.
 */
export function ProfessionalDetailCrossLinks({ links }: ProfessionalDetailCrossLinksProps) {
  const { t } = useTranslation();

  if (links.length === 0) return null;

  return (
    <section
      data-testid="professional-detail-cross-links"
      className="space-y-2 rounded-xl border border-[var(--bi-line)] bg-white/80 p-4 dark:bg-white/5"
      aria-label={t('domain.professionals.detail.crossLinks.title')}
    >
      <h2 className="text-sm font-semibold text-gray-950 dark:text-white">
        {t('domain.professionals.detail.crossLinks.title')}
      </h2>
      <p className="text-xs text-gray-500 dark:text-gray-400">
        {t('domain.professionals.detail.crossLinks.subtitle')}
      </p>
      <ul className="flex flex-col gap-2 sm:flex-row sm:flex-wrap">
        {links.map((link) => (
          <li key={link.id} className="min-w-0 sm:max-w-xs sm:flex-1">
            <Link
              to={link.href}
              data-testid={`professional-cross-link-${link.id}`}
              className="flex min-h-11 w-full items-center justify-center rounded-md border border-[var(--bi-line)] bg-white px-3 py-2.5 text-center text-sm font-semibold text-teal-800 hover:bg-teal-50 dark:bg-white/5 dark:text-teal-200 dark:hover:bg-white/10"
            >
              {t(link.labelKey)} →
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
